/* Keep LAI's Japanese coupon confirmation readable, including its srcdoc widget. */
(() => {
  const documents = new WeakSet();
  const frames = new WeakSet();
  const opening = 'ご協力ありがとうございます。';
  function format(message) {
    const walker = message.ownerDocument.createTreeWalker(message, 4);
    let node;
    while ((node = walker.nextNode())) {
      const position = node.data.indexOf(opening);
      if (position < 0) continue;
      const end = position + opening.length;
      if (end === node.length && node.nextSibling?.nodeName === 'BR') return;
      const remainder = node.splitText(end);
      remainder.before(message.ownerDocument.createElement('br'));
      return;
    }
  }
  function connectFrame(frame) {
    const connect = () => {
      try { if (frame.contentDocument) watch(frame.contentDocument); } catch (_) { /* Cross-origin frames are not accessible. */ }
    };
    if (!frames.has(frame)) {
      frames.add(frame);
      frame.addEventListener('load', connect);
    }
    connect();
  }
  function scan(root) {
    if (root.nodeType === 3) {
      const message = root.parentElement?.closest('.delay-coupon');
      if (message) format(message);
      return;
    }
    if (!root.querySelectorAll) return;
    if (root.matches?.('.delay-coupon')) format(root);
    root.querySelectorAll('.delay-coupon').forEach(format);
    if (root.matches?.('iframe')) connectFrame(root);
    root.querySelectorAll('iframe').forEach(connectFrame);
  }
  function watch(doc) {
    if (documents.has(doc)) return;
    documents.add(doc);
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') scan(record.target);
        else record.addedNodes.forEach(scan);
      }
    }).observe(doc, {subtree: true, childList: true, characterData: true});
    scan(doc);
  }
  watch(document);
})();
